export default function getEventHourRange(start, end, userLocale = 'es-AR') {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const formatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };

  const startTime = startDate.toLocaleTimeString(userLocale, formatOptions);
  const endTime = endDate.toLocaleTimeString(userLocale, formatOptions);

  return `${startTime} - ${endTime}`;
}
